import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { comnUtils, comnEnvs } from "@/comn/utils";
import { Grid } from "@/comn/components";
import { Page, Group, Layout, Button } from "@/comn/components";
import { useForm, useFetch, usePopup, useStore, useToast, useAuth, useGrid, useModal } from "@/comn/hooks";
import { BASE, APIS, SCHEMA_FORM_VHCL_MKER_CD_SRCH, SCHEMA_GRID_VHCL_MKER_CD } from "./services/ComnCdService";
import { Link } from "react-router-dom";

export const VehicleManufactureCodeList = (props: any) => {
    const pgeUid = "vhclMkerCdLst";
    const { t } = useTranslation();
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid });
    const toast = useToast();
    const modal = useModal();
    const params = props.params;

    const form = {
        vhclMkerCdSrch: useForm({
            defaultSchema: SCHEMA_FORM_VHCL_MKER_CD_SRCH,
            // defaultValues: { ...pgeStore?.form } || {},
        }),
    };

    const grid = {
        vhclMkerCdLst: useGrid({
            defaultSchema: SCHEMA_GRID_VHCL_MKER_CD,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const fetch = {
        getVhclMkerCdLst: useFetch({
            api: (page = grid.vhclMkerCdLst.page) => {
                return APIS.getVhclMkerCdLst(form.vhclMkerCdSrch.getValues(), page, grid.vhclMkerCdLst.size);
            },
            enabled: comnUtils.isEmpty(form.vhclMkerCdSrch.errors) && form.vhclMkerCdSrch.isSubmitted,
            key: [grid.vhclMkerCdLst.page, grid.vhclMkerCdLst.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.vhclMkerCdSrch.getValues(),
                    page: grid.vhclMkerCdLst.page,
                    size: grid.vhclMkerCdLst.size,
                });
            },
        }),
    };

    const handler = {
        click_Btn_Srch: () => {
            form.vhclMkerCdSrch.handleSubmit(
                () => {
                    grid.vhclMkerCdLst.setPage(0);
                    fetch.getVhclMkerCdLst.fetch(0);
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.osc.00003" });
                },
            )();
        },

        /* * */
        click_Btn_Apply: () => {
            const list: any[] = grid.vhclMkerCdLst.getChecked() || [];
            if (comnUtils.isEmpty(list)) {
                modal.openModal({ content: "msg.osc.00084" });
                return;
            }

            props?.callback?.({ data: list });
            modal.closeModal(props.id);
        },
    };

    const render = {
        grid_VhclMkerCdLst: {
            cell: {
                vhclMkerCd: (arg: any) => {
                    const { binding, rowValues, value } = arg;
                    return (
                        <Link
                            to={"#"}
                            onClick={(e) => {
                                e.preventDefault();
                                props?.callback?.({ code: value, label: rowValues.vhclMkerNm });
                                modal.closeModal(props.id);
                            }}
                        >
                            {arg.value}
                        </Link>
                    );
                },
            },
        },
    };

    useEffect(() => {
        handler.click_Btn_Srch();
        /* * */
        if (params?.multiple === true) {
            grid.vhclMkerCdLst.setOption("checkbox", true);
        }
    }, []);

    return (
        <Page title={t("T_VHCL_MKER_CD_LST")} info={true}>
            <form>
                <Group>
                    <Group.Body>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.vhclMkerCdSrch.schema.vhclMkerCd}></Group.Control>
                                <Group.Control {...form.vhclMkerCdSrch.schema.vhclMkerNm}></Group.Control>
                            </Group.Row>
                        </Group.Section>
                        <Layout direction="row">
                            <Layout.Left>
                                <Button
                                    role="reset"
                                    onClick={() => {
                                        form.vhclMkerCdSrch.reset();
                                    }}
                                ></Button>
                            </Layout.Left>
                            <Layout.Right>
                                <Button
                                    role="search"
                                    onClick={() => {
                                        handler.click_Btn_Srch();
                                    }}
                                ></Button>
                            </Layout.Right>
                        </Layout>
                    </Group.Body>
                </Group>
            </form>

            <Group>
                <Group.Body>
                    <Group.Section>
                        {/* * */}
                        {params?.multiple === true && (
                            <Layout>
                                <Layout.Right>
                                    <Button
                                        role="apply"
                                        onClick={() => {
                                            handler.click_Btn_Apply();
                                        }}
                                    ></Button>
                                </Layout.Right>
                            </Layout>
                        )}
                        <Grid
                            {...grid.vhclMkerCdLst.grid}
                            data={fetch.getVhclMkerCdLst.data?.vhclMkerList}
                            render={render.grid_VhclMkerCdLst}
                        />
                    </Group.Section>
                </Group.Body>
            </Group>
        </Page>
    );
};
